export const ROUTE_ENTREPRENEUR_SUBMISSION = "submission.view";
export const ROUTE_SUPPORTER_SUBMISSION = "supporterSubmission.view";
